/**
 * Whose account is it? The reviews a manager decides (S-27): a transfer waits because the account
 * it came from could not be proved the client's own by the bank's sender name.
 */
import type { AxiosInstance } from 'axios';
import authService from './auth.service';

export type ReviewReason = 'name_differs' | 'no_sender_name';

export interface SourceAccountReview {
  bank_transaction_id: string;
  deposit_request_id: string;
  client_id: string;
  account_id: string;
  account_last4: string;
  reason: ReviewReason;
  /** The name the bank reported for the sender; null when it reported none. */
  reported_sender_name: string | null;
  kyc_legal_name: string;
  amount: string;
  currency_code: string;
  posted_at: string;
}

export type ReviewDecision = 'verify' | 'refuse';

class SourceAccountsService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async listReviews(): Promise<SourceAccountReview[]> {
    const res = await this.api.get<SourceAccountReview[]>('/api/v1/ops/source-account-reviews');
    return res.data;
  }

  async decide(
    bankTransactionId: string,
    decision: ReviewDecision,
    note: string,
    mfaCode: string,
  ): Promise<void> {
    await this.api.post(`/api/v1/ops/source-account-reviews/${bankTransactionId}/decision`, {
      decision,
      note,
      mfa_code: mfaCode,
    });
  }
}

export default new SourceAccountsService();
